var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    strokeMiterlimit: 1.5,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90,16.87,16)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.015 0 0 2.015 -17.124 -16.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.87 9.5v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.006 18.435 4.864 4.864 4.864-4.864"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.bd3f627bddfdb6ba1f324cd6c02c8327.svg";
export { ForwardRef as ReactComponent };